<template>
  <div>
    <a-checkbox-group v-model="checkedIdList" style='width:100%'>
      <a-modal
        :confirmLoading='confirmLoading'
        :title='title'
        :visible='visible'
        :width='1000'
        cancelText='关闭'
        @cancel='handleCancel'
        @ok='handleOk'>
        <a-alert message="表单固定在随访周期时间窗的开始日期当天上午9点陆续推送。" type="info" show-icon />
        <br>
        <a-table :columns='columns' :dataSource='dataSource' :pagination='false'  rowKey='id' size='small'>
      <span slot="formList" slot-scope="text,record">
          <a-row :gutter="20">
            <a-col :span="8" v-for="(form,index) in record.formList" :key="index">
                <a-checkbox :value="form.id">{{ form.formName }}</a-checkbox>
            </a-col>
          </a-row>
      </span>
        </a-table>
      </a-modal>
    </a-checkbox-group>
  </div>

</template>

<script>
import { postAction } from '@api/manage'

export default {
  name: 'PushFormModel',
  data() {
    return {
      title: '表单自动推送',
      visible: false,
      confirmLoading: false,
      dataSource: [],
      checkedIdList:[],
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '周期序号',
          width:100,
          align:'center',
          customRender: (text, record, index) => `V${index+1}`
        },
        {
          title: '周期名称',
          width:200,
          dataIndex: 'name',
          align:'center',
          ellipsis: true,
        },
        {
          title: '表单',
          align: 'center',
          scopedSlots: {customRender: 'formList'},
        },
      ]
    }
  },
  created() {
  },
  methods: {
    edit(dataSource) {
      const checkedIdList = []
      if(dataSource){
        dataSource.forEach(periodItem=>{
          if(periodItem.formList){
            periodItem.formList.forEach(form=>{
              if(form.push ==='1'){
                checkedIdList.push(form.id)
              }
            })
          }
        })
      }
      this.checkedIdList = checkedIdList
      this.dataSource = JSON.parse(JSON.stringify(dataSource))
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      this.checkedIdList.forEach(id=>{

      })
      if(this.dataSource){
        this.dataSource.forEach(periodItem=>{
          if(periodItem.formList){
            periodItem.formList.forEach(form=>{
              if(this.checkedIdList.indexOf(form.id)>=0){
                form.push ='1'
              }else{
                form.push ='0'
              }
            })
          }
        })
      }
      const data = []
      this.dataSource.forEach(periodItem=>{
        if(periodItem.formList){
          periodItem.formList.forEach(form=>{
            data.push({
              id:form.id,
              push:form.push
            })
          })
        }
      })
      // 触发表单验证
      postAction('/project/projectPeriodItem/formPushSetting',data).then((res) => {
        if (res.success) {
          that.$message.success(res.message)
          that.$emit('ok')
          that.close()
        } else {
          that.$message.warning(res.message)
        }
      }).finally(() => {
        that.confirmLoading = false
      })
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>

<style scoped>

</style>
